module.exports = __webpack_public_path__ + "static/media/fourWarriors-4.baf82fd7.png";